import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'kiene-geschlecht-eingeben-dialog',
    templateUrl: './geschlecht-eingeben-dialog.component.html',
    styleUrls: ['./geschlecht-eingeben-dialog.component.scss'],
})
export class GeschlechtEingebenDialogComponent {
    geschlechtId: number = null;

    constructor(
        public dialogRef: MatDialogRef<GeschlechtEingebenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data,
    ) {
        const initial = Number(this.data?.geschlecht_id);
        if (initial === 1 || initial === 2) {
            this.geschlechtId = initial;
        }
    }
}
